import logo from './qed-logo.svg';

const LogoFull = () => <img src={logo} alt="QED" style={{ height: 28 }} />;

export default LogoFull;
